export default {
  data() {
    return {
      // wrapper: null,
      // queryBar: null,
      // turnPage: null,
      tableHeight: 600,
      // spacing: 71
    }
  },
  filters: {
    // 手机号脱敏
    hideCorpPhone(value) {
      let pat = /(\d{3})\d*(\d{4})/
      return value.replace(pat, '$1****$2')
    }
  }


  // mounted() {
  // this.$nextTick(() => {
  //   setTimeout(() => {
  //     this.wrapper = document.querySelector('.el-main')
  //     this.queryBar = document.querySelector('.query-bar')
  //     this.turnPage = document.querySelector('.pagination-wrapper')

  //     this.onResizeView()
  //   }, 150)
  // })

  // window.addEventListener('resize', this.onResizeView, false)
  // this.$once('hook:beforeDestroy', () => {
  //   window.removeEventListener('resize', this.onResizeView, false)
  // })
  // },

  // methods: {
  //   onResizeView() {
  // const { spacing, wrapper, turnPage, queryBar } = this

  // const WRAPPER_HEIGHT = wrapper.clientHeight || 580
  // const TURN_PAGE_HEIGHT = turnPage.clientHeight || 65
  // const QUERY_BAR_HEIGHT = queryBar.clientHeight || 184

  // this.tableHeight = WRAPPER_HEIGHT - QUERY_BAR_HEIGHT - TURN_PAGE_HEIGHT - spacing + 'px'
  //   }
  // }
}
